export default __webpack_public_path__ + "static/media/lockUnlocked.90e67de5.svg";